export const featureKey = 'genesysCloudFeatureToggles';
